import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { Transfer } from '../../models/transfer';
import { TransfersOmniService } from '../transfers-omni.service';
import { TransfersOmniEventType } from '../transfers-omni.event.type';
import { CurrentBalanceEventType } from '../../../shared/current-balance/current-balance.event.type';
import { EventTypes } from '../../../shared/EventTypes';
import { ModalAntifraudWarningComponent } from '../../../shared/modal-antifraud-warning/modal-antifraud-warning.component';
import { MatDialog } from '@angular/material';
import { TransferSituation } from '../../models/transferSituation';
import { Router } from '@angular/router';
import { TransactionResponseStatus } from '../../transfers-other-banks/transfer-response/models/transaction-response-status.enum';
import { TransactionHandlerService } from '../../transfers-other-banks/transfer-response/services/transaction-handler.service';
import { AntifraudeDataModel } from '../../transfers-other-banks/transfer-response/models/antifraude-data.model';

@Component({
	selector: 'app-omni-transfer-result',
	templateUrl: './transfer-result.component.html',
	styleUrls: ['./transfer-result.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransferResultComponent implements OnInit, OnDestroy {

	@Input() flow: string;
	@Input() submited = false;
	@Input() transferData: Transfer;

	@Output() setTitleSubtitle: EventEmitter<any> = new EventEmitter<any>();

	private view = '[data-component="transfer-result"]';

	active = false;

	isScheduled: boolean;
	showExportButtons: boolean;
	showAntifraudScreen: boolean;
	nameTransfer: string;
	valueTransfer: number;
	dateTransfer: string;
	antifraudeModel: AntifraudeDataModel;

	constructor(
		private transferOBService: TransfersOmniService,
		public dialog: MatDialog,
		private router: Router,
		private transactionResponseHandler: TransactionHandlerService,
	) {}

	ngOnInit() {
		AppEventDispatcher.listen(TransfersOmniEventType.STEPS.TRANSFER_RESULT, data => {
			if (!data.show) {
				this.hide();
				return;
			}

			if(!this.awaitingAntifraudAnalysis && !this.antifraudCanceled) {
				this.active = true;
			}

			this.show();
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransfersOmniEventType.STEPS.TRANSFER_RESULT);
	}

	show() {
		this.isScheduled = this.transferOBService.scheduleSpan;

		if (this.awaitingAntifraudAnalysis) {
			this.setTitleSubtitle.emit({
				title: 'Importante',
				subtitle: 'Para sua segurança, a transferência abaixo está em análise!',
			});
			this.setDataAntifraudScreen();
			return
		}

		this.showExportButtons = this.transferData.success;

		this.setTitleSubtitle.emit({
				title: 'Resumo da Transferência Entre Contas',
				subtitle: 'Transferência financeira entre contas do Omni Banco.',
		});

		AppEventDispatcher.dispatch(TransfersOmniEventType.ACTIONS.BUTTONS, { show: false });

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();

			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut});
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut});
			AppEventDispatcher.dispatch( CurrentBalanceEventType.BALANCE_UPDATE, null);

			AppEventDispatcher.dispatch(EventTypes.EXPORT_BUTTONS.DATA_TRANSACTION, {
				transferNumber: this.transferData.confirmationCode,
				receiptType: 'EntreContas'
			});
		});
	}

	hide() {
		TweenMax.to(this.view, 2.8, { left: '-100%', ease: Quint.easeOut, onComplete: () => {
			this.active = false;
		}});
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() - 30;
	}

	get awaitingAntifraudAnalysis(): boolean {
		return this.transferData.situation === TransactionResponseStatus.AGUARDANDO_ANALISE_ANTIFRAUDE;
	}


	get antifraudCanceled(): boolean {
		return this.transferData.situation === TransactionResponseStatus.CANCELADA_SUSPEITA_FRAUDE;
	}


	nagigateToDashboard(): void {
		this.router.navigate(["/dashboard"], { skipLocationChange: true });
	}

	setDataAntifraudScreen(): void {
		this.antifraudeModel = this.transactionResponseHandler.getAntifraudModel();
		this.nameTransfer = this.antifraudeModel.name;
		this.valueTransfer = this.antifraudeModel.value;
		this.dateTransfer = this.antifraudeModel.dateTransaction;
		this.showAntifraudScreen = this.antifraudeModel.showAntifraude;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-omni/transfer-result/transfer-result.component.ts